/*
 * CAPTURE-OWNED MODULE
 * A field read by position only: it has a value zone and no anchor zone, so
 * extraction reads the box where it was drawn (capture-app templateExtractor,
 * POSITION_ONLY_CONFIDENCE). Derived from the zones; nothing is stored.
 */

export const POSITION_ONLY_LABEL = 'Position only';

export const POSITION_ONLY_TITLE =
  'Read from this spot on the page, with no label. Use only for text that never moves, such as a letterhead.';

/** True when the zones hold a value zone and no anchor zone. */
export function isPositionOnly(fieldZones) {
  const zones = fieldZones || [];
  return zones.some(z => z.zone_type === 'field') && !zones.some(z => z.zone_type === 'anchor');
}
